import React, { useCallback, useEffect, useState } from "react";
import { Avatar, Button, Input, List, Modal, Select, Tag } from "antd";
import { useTranslation } from "react-i18next";
import "./InviteTeamWorkbenchModal.css";
import downArrow from "../../assets/icons/chevron-down-invite.svg";
import copy from "../../assets/icons/Copy.svg";
import { useGetWorkBenchPermissionsQuery, useStaffShareModelsMutation, useUpdateUserPermisionMutation, useWorkBenchPermisionListQuery } from "../../service/apiSlices/workbench";
import { showErrorToast, showSuccessToast } from "../../utilities/toastUtils";
import EmailInput from "../inputArea/EmailInput";

const InviteTeamWorkbenchModal = ({ visible, onClose }: any) => {
    const { t } = useTranslation("common");
    const secret_key = sessionStorage.getItem('secret_key');
    const { data: getWorkBenchPermissions, refetch } = useGetWorkBenchPermissionsQuery(secret_key, { skip: !visible })
    const [updateUserPermission] = useUpdateUserPermisionMutation()
    const [staffShareModels] = useStaffShareModelsMutation()
    const { data: workBenchPermision } = useWorkBenchPermisionListQuery("", { skip: !visible })
    const [userPrivilege, SetUserPrivilage] = useState<any>("")

    useEffect(() => {
        if (workBenchPermision?.data) {
            let options = workBenchPermision?.data?.map((privilage: any) => ({
                lable: privilage?.permission_name,
                value: privilage?.permission_name,
            }))
            if (options) {
                SetUserPrivilage(options)
            }
        }
    }, [workBenchPermision?.data])

    const handlePrivilegeChange = (value: number, staffId: number, index: number) => {

        let payload = {
            secret_key: secret_key,
            email: [getWorkBenchPermissions?.data[index]?.email],
            workbench_permission: value
        }

        updateUserPermission(payload).unwrap()
            .then((response: any) => {
                if (response?.status_code === 200) {
                    showSuccessToast(response.message);
                    refetch()
                } else {
                    showErrorToast(response.message);
                }
            }).catch((error: any) => {
                showErrorToast('Failed to change permission');
            })
    };

    const handleInvite = useCallback((newEmails: string[]) => {

        let payload = {
            secret_key: secret_key,
            email: newEmails,
            workbench_permission: "view-only"
        };

        staffShareModels(payload).unwrap()
            .then((response: any) => {
                if (response?.status_code === 200) {
                    showSuccessToast(response.message);
                    refetch()
                } else {
                    showErrorToast(response.message);
                }
            }).catch((error: any) => {
                showErrorToast('Failed to add staff');
            })
    }, [secret_key, staffShareModels, refetch])

    // Function to get avatar background color based on name
    const getAvatarColor = (name: any) => {
        const firstLetter = name?.charAt(0).toUpperCase();
        const colors: any = {
            'A': '#54a0ff',
            'D': '#9b59b6',
            'P': '#e74c3c',
            'S': '#27ae60',
            'W': '#3498db',
        };

        return colors[firstLetter] || '#1890ff';
    };

    // Function to get avatar text (first letter of first name)
    const getAvatarText = (name: any) => {
        return name?.charAt(0).toUpperCase();
    };


    return (
        <Modal
            centered
            open={visible}
            onOk={onClose}
            onCancel={onClose}
            footer={null}
            width={450}
            className="invite-team-workbench-modal-container"
        >
            <div className="invite-team-workbench-modal">
                <div className="invite-team-workbench-modal-header">
                    <h4 className="invite-team-workbench-modal-title">{t("inviteTeamWorkbenchModal.title")}</h4>
                </div>
                <div className="invite-team-workbench-modal-body">
                    <div className="search-input-wrapper">
                        <label className="invite-team-workbench-modal-email-label">{t("link")}</label>
                        <div className="position-relative">
                            <Input type="text" value={"https://www.figma.com/design/UqTTZ34e"} placeholder={t("link")} className="invite-team-workbench-modal-input" readOnly />
                            <Button className="border-0 shadow-0 bg-transparent copy-btn"><img src={copy} alt="copy" /></Button>
                        </div>
                    </div>

                    <EmailInput
                        onInvite={handleInvite}
                        visible={visible}
                    />

                    <div className="user-list">
                        <List
                            itemLayout="horizontal"
                            dataSource={getWorkBenchPermissions?.data}
                            renderItem={(item: any, index: number) => (
                                <List.Item
                                    actions={
                                        (!(item?.permission_name[0] === "Owner")) ? [
                                            <Select
                                                onChange={(value) => handlePrivilegeChange(value, item?.user_id, index)}
                                                disabled={item?.permission_name[0] === "Owner"}
                                                value={item?.permission_name[0]}
                                                className="userPermissionDropdown"
                                                options={userPrivilege}
                                                suffixIcon={<img src={downArrow} alt="icon" className="down-arrow-user-access" />}
                                                bordered={false}
                                            />
                                        ] : []
                                    }
                                >
                                    <List.Item.Meta
                                        avatar={
                                            <Avatar
                                                icon={item?.profile_image ? <img src={item?.profile_image} alt="avatar" /> : null}
                                                style={{ backgroundColor: getAvatarColor(item?.email) }}
                                            >
                                                {getAvatarText(item?.email)}
                                            </Avatar>
                                        }
                                        title={
                                            <div className="d-flex justify-content-between">
                                                <div>{item.email}</div>
                                                {item?.permission_name[0] === "Owner" ? (
                                                    <Tag className="border-0 bg-transparent text-dark me-0">
                                                        {item?.permission_name[0]}
                                                    </Tag>
                                                ) : null}
                                            </div>
                                        }
                                    />
                                </List.Item>
                            )}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default React.memo(InviteTeamWorkbenchModal);